import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Card,
    CardHeader,
    CardContent,
} from '@mui/material';

import { EligibilityData } from '../types';
import { createEligibilityData } from '../services/eligibilityService';
import EligibilityForm from './components/EligibilityForm';
import { Dayjs } from 'dayjs';

const EligibilityAdd = () => {
    const navigate = useNavigate();
    const [eligibilityData, setEligibilityData] = useState<EligibilityData>({});
    const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setFieldErrors({});
        
        try {
            await createEligibilityData(eligibilityData);
            navigate('/eligibility');
        } catch (error) {
            if (error instanceof Error && error.message) {
                try {
                    const errorData = JSON.parse(error.message);
                    if (errorData.Field && errorData.Message) {
                        setFieldErrors({ [errorData.Field]: errorData.Message });
                    }
                } catch {
                    console.error('[Error Creating Eligibility Data]', error);
                }
            }
        }
    };

    const handleDateChange = (field: keyof EligibilityData, value: Dayjs | null) => {
        setEligibilityData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleInputChange = (field: keyof EligibilityData, value: any) => {
        setEligibilityData(prev => ({
            ...prev,
            [field]: value
        }));
        
        // Clear field error when user starts typing
        if (fieldErrors[field]) {
            setFieldErrors(prev => {
                const { [field]: _, ...rest } = prev;
                return rest;
            });
        }
    };

    const handleCancel = () => {
        navigate('/eligibility');
    };

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4 }}>
            <Card>
                <CardHeader title="Add New Eligibility Record" />
                <CardContent>
                    <EligibilityForm
                        eligibilityData={eligibilityData}
                        fieldErrors={fieldErrors}
                        onSubmit={handleSubmit}
                        onInputChange={handleInputChange}
                        onDateChange={handleDateChange}
                        submitButtonText="Create Eligibility Record"
                        showCancelButton={true}
                        onCancel={handleCancel}
                    />
                </CardContent>
            </Card>
        </Box>
    );
};

export default EligibilityAdd;
